import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.19 8.06h-1.84V4a.77.77 0 0 0-.29-.59l-2.59-2a.75.75 0 0 0-1 0L4.92 3.65a.77.77 0 0 0-.26.57v1.11H2.82a.74.74 0 0 0-.75.75V14a.75.75 0 0 0 .75.75h10.37a.75.75 0 0 0 .75-.75V8.81a.74.74 0 0 0-.75-.75Zm-.75 5.19H3.57V6.83h1.84a.76.76 0 0 0 .75-.75V4.56L8 3l1.85 1.4v4.41a.75.75 0 0 0 .75.75h1.84Zm-1.19-2.45v1.3H10v-1.3Zm-5.19 0v1.3h-1.3v-1.3Zm0-2.69v1.3h-1.3v-1.3Zm2.59 2.69v1.3H7.36v-1.3Zm0-2.69v1.3H7.36v-1.3Zm0-2.68v1.3H7.36v-1.3Z';
const draw24px =
  'M20,21.67H4a.76.76,0,0,1-.75-.75V8.71A.75.75,0,0,1,4,8H7.25V5.84a.77.77,0,0,1,.26-.57l4-3.42a.75.75,0,0,1,1,0l4,3.14a.74.74,0,0,1,.29.59v6.61H20a.75.75,0,0,1,.75.75v8A.76.76,0,0,1,20,21.67ZM4.75,20.17h14.5v-6.5H16a.76.76,0,0,1-.75-.75v-7L12,3.39,8.75,6.18V8.71A.76.76,0,0,1,8,9.46H4.75ZM17,16H15v2h2ZM9,16H7v2H9Zm0-4.15H7v2H9ZM13,16H11v2h2Zm0-4.15H11v2h2Zm0-4.13H11v2h2Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BuildingIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'building'),
) as IconWithRender;

BuildingIcon.displayName = 'BuildingIcon';
BuildingIcon.propTypes = Icon.propTypes;
BuildingIcon.renderIcon = (props) => <BuildingIcon {...props} />;
export default BuildingIcon;
